import { unflatten } from 'flat';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App/App';

// const Schema = require('./helpers/configSchema');

const element = document.getElementById('calc-pension-pot') as HTMLElement;

try {
  const { content } = element.dataset;
  // const ajv = new Ajv();
  // const valid = ajv.validate(Schema, parsedConfig);

  // if (!valid) { //   throw ajv.errorsText(); // }

  unflatten(JSON.parse(decodeURIComponent(content || '')));

  ReactDOM.render(<App {...{ content }} />, element);
} catch (error) {
  ReactDOM.render(<App {...{
    errors: {
      title: element.dataset.errorTitle,
      body: element.dataset.errorBody,
      button: element.dataset.errorButton,
      link: element.dataset.errorLink,
    },
  }}
  />, element);
}



// WEBPACK FOOTER //
// ./src/index.tsx